/*
 * Top Floor storefront interactions.
 * This file only handles behavior that Shopify does not provide by default:
 * product image switching, quantity buttons, variant selection, and the
 * password-page mailing-list reveal.
 */

document.addEventListener("DOMContentLoaded", function () {
  initializeProductGallery();
  initializeQuantityControls();
  initializeProductVariants();
  initializePasswordList();
  initializePasswordVisibility();
});

/** Switches the large product image when a thumbnail is selected. */
function initializeProductGallery() {
  document.querySelectorAll("[data-product-section]").forEach(function (section) {
    const mainImage = section.querySelector("[data-product-main-image]");
    const thumbnails = section.querySelectorAll("[data-product-thumbnail]");

    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener("click", function () {
        const imageSource = thumbnail.dataset.imageSrc;
        const imageAlt = thumbnail.dataset.imageAlt || "";

        if (!imageSource) return;

        // Remove responsive attributes so the browser uses the selected source.
        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.src = imageSource;
        mainImage.alt = imageAlt;

        thumbnails.forEach(function (item) {
          item.classList.remove("is-active");
        });

        thumbnail.classList.add("is-active");
      });
    });
  });
}

/** Adds reusable plus and minus controls to product quantity fields. */
function initializeQuantityControls() {
  document.querySelectorAll("[data-quantity-minus]").forEach(function (button) {
    button.addEventListener("click", function () {
      const form = button.closest("form");
      const input = form && form.querySelector("[data-quantity-input]");

      if (!input) return;

      const currentValue = Number(input.value) || 1;
      input.value = Math.max(1, currentValue - 1);
    });
  });

  document.querySelectorAll("[data-quantity-plus]").forEach(function (button) {
    button.addEventListener("click", function () {
      const form = button.closest("form");
      const input = form && form.querySelector("[data-quantity-input]");

      if (!input) return;

      const currentValue = Number(input.value) || 1;
      input.value = currentValue + 1;
    });
  });
}

/** Updates product price and availability when a variant is selected. */
function initializeProductVariants() {
  document.querySelectorAll("[data-variant-select]").forEach(function (select) {
    const section = select.closest("[data-product-section]");
    const price = section && section.querySelector("[data-product-price]");
    const addButton = section && section.querySelector("[data-add-to-cart]");

    if (!section || !price || !addButton) return;

    function updateVariant() {
      const selectedOption = select.options[select.selectedIndex];
      const isAvailable = selectedOption.dataset.variantAvailable === "true";

      price.textContent = selectedOption.dataset.variantPrice || price.textContent;
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? "ADD TO BAG" : "ARCHIVED";
    }

    select.addEventListener("change", updateVariant);
  });
}

/** Reveals or hides the Klaviyo form on the password page. */
function initializePasswordList() {
  const toggle = document.querySelector("[data-password-list-toggle]");
  const list = document.querySelector("[data-password-list]");

  if (!toggle || !list) return;

  toggle.addEventListener("click", function () {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";

    toggle.setAttribute("aria-expanded", String(!isOpen));
    list.hidden = isOpen;
  });
}

/** Allows visitors to show or hide the password they are typing. */
function initializePasswordVisibility() {
  const input = document.querySelector("[data-password-input]");
  const button = document.querySelector("[data-password-visibility]");

  if (!input || !button) return;

  button.addEventListener("click", function () {
    const isVisible = input.type === "text";

    input.type = isVisible ? "password" : "text";
    button.setAttribute("aria-pressed", String(!isVisible));
    button.setAttribute(
      "aria-label",
      isVisible ? "Show password" : "Hide password"
    );

    input.focus();
  });
}

